import type { GoogleDriveFile, ParentFolderContext } from './types';
import { googleFetch } from '../client';

export type GoogleDriveFilesCreateRequest = ParentFolderContext & {
  name: string;
  mime_type: string;
  content: string;
};

export type GoogleDriveFilesCreateResponse = GoogleDriveFile;

export async function googleDriveFilesCreate(
  params: GoogleDriveFilesCreateRequest
): Promise<GoogleDriveFilesCreateResponse> {
  return googleFetch<GoogleDriveFilesCreateResponse>(
    '/rpc/google_drive_files_create',
    {
      body: params,
    }
  );
}
